'use client'

import { useCallback, useEffect, useState } from 'react'
import { usePathname } from 'next/navigation'
import dynamic from 'next/dynamic'

const AdZone = dynamic(() => import('@/app/(locale)/cricket-news/AdZone'), {
  ssr: false
})

const InterstitialAd = () => {
  const pathname = usePathname()
  const [show, setShow] = useState(false)
  const [countdown, setCountdown] = useState(6)
  const [adLoaded, setAdLoaded] = useState(false)

  useEffect(() => {
    if (pathname === '/') {
      setShow(true)
      setCountdown(6)
      setAdLoaded(false)
    }
  }, [pathname])

  useEffect(() => {
    if (!show || !adLoaded || countdown === 0) return

    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev === 1) {
          setShow(false)
          clearInterval(timer)
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(timer)
  }, [show, adLoaded, countdown])

  const handleAdLoaded = useCallback(() => {
    setAdLoaded(true)
  }, [])

  if (!show) return null

  return (
    <div
      className={`fixed inset-0 bg-black bg-opacity-70  flex items-center justify-center ${
        adLoaded ? 'z-[9999]' : '-z-[9999] opacity-0'
      }`}
    >
      <div className=" max-w-[300px] w-full mx-4">
        <div className="bg-slate-800 rounded-tl-[5px] rounded-tr-[5px] text-white text-sm font-medium flex items-center justify-between px-4 py-2 top-0 left-0 right-0 z-10">
          <span>
            Closing in {countdown < 10 ? ` 0${countdown}` : countdown}{' '}
            {countdown <= 1 ? 'second' : 'seconds'}
          </span>
          <button
            onClick={() => setShow(false)}
            className="text-white text-lg font-bold"
            aria-label="Close interstitial ad"
          >
            ✕
          </button>
        </div>
        <div className="h-[250px]">
          <AdZone onLoadComplete={handleAdLoaded} />
        </div>
      </div>
    </div>
  )
}

export default InterstitialAd
